/* eslint-disable require-jsdoc */
import React from 'react';
import {isValid} from '../../utils/validate.js';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faFacebook, faTwitter} from '@fortawesome/free-brands-svg-icons';
import {faPhoneAlt} from '@fortawesome/free-solid-svg-icons';


const venueSocial = (venue) => {
  return (
    <div className="hearby-social">
      <div className="hearby-social-icons-wrapper hearby-grid">

        { isValid(venue.socialInfo.phone) ?
        <div className="hearby-grid-item">
          <a href={
            `tel:${venue.socialInfo.phone}`}
          target="_blank" rel='noreferrer'
          className="hearby-phone-link-mobile hearby-icon
               hearby-social-icon hearby-social-icon-phone-alt">
            <FontAwesomeIcon icon={faPhoneAlt} />
          </a>
        </div>: null}

        {isValid(venue.socialInfo.facebook) ?
        <div className="hearby-grid-item">
          <a href={
            `${venue.socialInfo.facebook}`}
          target="_blank" rel='noreferrer'
          className="hearby-icon hearby-social-icon
               hearby-social-icon-facebook">
            <FontAwesomeIcon icon={faFacebook} />
          </a>
        </div>: null}

        {isValid(venue.socialInfo.twitter) ?
        <div className="hearby-grid-item">
          <a href={
            `${venue.socialInfo.twitter}`}
          target="_blank" rel='noreferrer'
          className="hearby-icon hearby-social-icon
            hearby-social-icon-twitter">
            <FontAwesomeIcon icon={faTwitter} />
          </a>
        </div>: null}

      </div>
    </div>

  );
};

export default venueSocial;
